import React from "react";
import Header from "~/components/common/Header";
import { type HeaderProps } from "~/components/common/Header";

interface PageContainerProps {
  children: React.ReactNode;
  showHeader?: boolean;
  headerProps?: HeaderProps;
}

export default function PageContainer({ children, showHeader = true, headerProps }: PageContainerProps) {
  // Calculate margin-top based on header and announcement visibility
  // Announcement: 32px (h-8), Header: 78px (h-[78px])
  const getMarginTop = () => {
    if (!showHeader) return "";
    if (headerProps?.showAnnouncement) return "pt-[110px]"; // 32px announcement + 78px header
    return "pt-[78px]"; // Just header height
  };

  return (
    <>
      {showHeader && <Header {...headerProps} />}
      <div className={`${getMarginTop()} flex min-h-screen flex-col justify-between bg-[#F8F8F2]`}>{children}</div>
    </>
  );
}
